import React from 'react';
import { Region } from '@fx-ui/platform-sdk';
export interface IPageContext {
    initLocale: (region?: Region) => void;
    initDayjs: (region?: Region) => void;
}

const PageContext = React.createContext<IPageContext>({
    initLocale: () => {},
    initDayjs: () => {}
});
PageContext.displayName = 'PageContext';
export default PageContext;
